import { render, staticRenderFns } from "./marginEditor.vue?vue&type=template&id=9441d920"
import script from "./marginEditor.vue?vue&type=script&lang=js"
export * from "./marginEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports